export default __webpack_public_path__ + "static/media/double-arrow-right.2653558a.svg";